(function(){
  "use strict";

  var drawer = null;

  function q(s,r){ return (r||document).querySelector(s); }
  function qa(s,r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); }

  function openDrawer(){
    drawer = drawer || q("[data-cart-drawer]");
    if(!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden","false");
    var close = q("[data-cart-close]", drawer);
    if(close) close.focus();
    document.addEventListener("keydown", escClose);
  }
  function closeDrawer(){
    if(!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden","true");
    document.removeEventListener("keydown", escClose);
  }
  function escClose(e){ if(e.key === "Escape") closeDrawer(); }

  function refreshCart(){
    return fetch("/?section_id=cart-drawer")
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = q("[data-cart-drawer]", doc);
        var live = q("[data-cart-drawer]");
        if(fresh && live){
          var wasOpen = live.classList.contains("is-open");
          live.innerHTML = fresh.innerHTML;
          if(wasOpen) live.classList.add("is-open");
        }
        return fetch("/cart.js").then(function(r){ return r.json(); });
      })
      .then(function(cart){
        qa("[data-cart-count]").forEach(function(el){ el.textContent = cart.item_count; });
      });
  }

  document.addEventListener("click", function(e){
    var openBtn = e.target.closest("[data-cart-open]");
    if(openBtn){ e.preventDefault(); openDrawer(); return; }

    if(e.target.closest("[data-cart-close]") || e.target.closest(".drawer__scrim")){
      e.preventDefault(); closeDrawer(); return;
    }

    var remove = e.target.closest("[data-line-remove]");
    if(remove){
      e.preventDefault();
      fetch("/cart/change.js", {
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body: JSON.stringify({ id: remove.getAttribute("data-line-remove"), quantity: 0 })
      }).then(refreshCart);
      return;
    }

    var size = e.target.closest("[data-variant]");
    if(size){
      var form = size.closest("form");
      if(!form) return;
      qa("[data-variant]", form).forEach(function(b){ b.setAttribute("aria-pressed","false"); });
      size.setAttribute("aria-pressed","true");
      var input = q("[name=id]", form);
      if(input) input.value = size.getAttribute("data-variant");
      var submit = q("[data-add]", form);
      if(submit){ submit.disabled = false; submit.textContent = "add to bag"; }
    }
  });

  document.addEventListener("submit", function(e){
    var form = e.target.closest("[data-add-form]");
    if(!form) return;
    e.preventDefault();
    var btn = q("[data-add]", form);
    if(btn) btn.textContent = "adding";
    fetch("/cart/add.js", { method:"POST", body: new FormData(form) })
      .then(function(){ return refreshCart(); })
      .then(function(){
        if(btn) btn.textContent = "added to bag";
        openDrawer();
      });
  });

  function fitMark(){
    var el = q("[data-fit]");
    if(!el || !el.parentElement) return;
    el.style.fontSize = "100px";
    var w = el.getBoundingClientRect().width;
    var avail = el.parentElement.getBoundingClientRect().width;
    if(!w || !avail) return;
    el.style.fontSize = (100 * avail / w) + "px";
  }

  function initFollow(){
    var area = q("[data-follow-area]"), el = q("[data-follow]");
    if(!area || !el) return;
    var f = {tx:null, ty:null, cx:null, cy:null, s:1, big:false};
    var touch = window.matchMedia("(hover: none)");
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
    area.addEventListener("mousemove", function(e){
      var r = area.getBoundingClientRect();
      f.tx = e.clientX - r.left + 12;
      f.ty = e.clientY - r.top + 12;
      f.big = !!e.target.closest("a");
    });
    (function tick(){
      var r = area.getBoundingClientRect();
      var tx = f.tx, ty = f.ty;
      if(touch.matches || tx === null){ tx = r.width / 2; ty = r.height - 64; }
      if(f.cx === null){ f.cx = tx; f.cy = ty; }
      var k = reduce.matches ? 1 : 0.12;
      f.cx += (tx - f.cx) * k;
      f.cy += (ty - f.cy) * k;
      f.s += ((f.big && !touch.matches ? 1.6 : 1) - f.s) * (reduce.matches ? 1 : 0.15);
      el.style.transform = "translate(" + f.cx + "px," + f.cy + "px) translate(-50%,-50%) scale(" + f.s + ")";
      requestAnimationFrame(tick);
    })();
  }
  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", initFollow);
  } else {
    initFollow();
  }

  window.addEventListener("resize", fitMark);
  window.addEventListener("load", fitMark);
  document.addEventListener("DOMContentLoaded", fitMark);
  document.addEventListener("shopify:section:load", fitMark);
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(fitMark);
  requestAnimationFrame(fitMark);
  setTimeout(fitMark, 300);
})();